import eventBus from '../eventbus'

export function emitEvent<T>(eventName: TrackingEvent, data: T) {
    if (!eventBus) {
        console.error('EventBus not found.')
        return
    }

    if ((import.meta.env.MODE ?? '') === 'development') {
        // Prevent emitting events in development mode but debug them instead.
        printEvent(eventName, data)
        return
    }

    eventBus.emit(eventName, data)
}

export function printEvent<T>(eventName: TrackingEvent, data: T) {
    try {
        console.debug(
            "-------------------------\n",
            "Event name: " + eventName + "\n",
            "Event Data:\n", data ?? 'No data found in event', "\n",
            "-------------------------\n",
        )
    } catch (e) {
        console.error(`Failed to debug event '${eventName}': ${e}`)
    }
}

export const EventCheckoutStep: TrackingEvent = 'v1.checkout.step'
export const EventCartAdd: TrackingEvent = 'v1.cart.add'
export const EventCartRemove: TrackingEvent = 'v1.cart.remove'
export const EventCheckoutConfirmation: TrackingEvent = 'v1.checkout.confirmation'
export const EventProductClick: TrackingEvent = 'v1.product.click'
export const EventCollectionImpression: TrackingEvent = 'v1.collection.impression'
export const EventProductView: TrackingEvent = 'v1.product.view'

type TrackingEvent =
    'v1.checkout.step' |
    'v1.cart.add' |
    'v1.cart.remove' |
    'v1.checkout.confirmation' |
    'v1.product.click' |
    'v1.collection.impression' |
    'v1.product.view'

export const CheckoutStepCart: CheckoutStep = 'cart'
export const CheckoutStepCredentials: CheckoutStep = 'credentials'
export const CheckoutStepPaymentSelection: CheckoutStep = 'payment-selection'
export const CheckoutStepCreateOrder: CheckoutStep = 'create-order'
export const CheckoutStepUpdateOrder: CheckoutStep = 'update-order'

type CheckoutStep = 'cart' | 'credentials' | 'payment-selection' | 'create-order' | 'update-order'


export interface EventProduct {
    ID: string,
    name: string,
    variants: EventProductVariant[]
    price: number,
    attributes: { [key: string]: string },
}

interface EventProductVariant {
    ID: string
    name: string,
    price: number,
    attributes: { [key: string]: string },
}
